<template>
    <hr class="dr-divider">
</template>

<script lang="ts" setup></script>

<style lang="scss">
.dr-divider {
  border-top: 2px solid rgb(from var(--color-forest-green-60) r g b / 0.10);
  height: 0;
  box-shadow: 0px 2px 4px 0px rgb(from var(--color-forest-green-60) r g b / 0.10);
  width: calc(100vw - 8px);
  margin-left: calc(50% - 50vw);
}
</style>
